import { Station } from '../../models';
import { StationUpdateData } from '../../packages/events/types';
import {
	SET_STATIONS,
	StationActionTypes,
	UPDATE_STATION,
} from '../types';

export const setStations = (stations: Station[]): StationActionTypes => ({
	payload: { state: stations },
	type: SET_STATIONS,
});

export const updateStation = (
	service: StationUpdateData
): StationActionTypes => ({
	payload: { service: service },
	type: UPDATE_STATION,
});